import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import cloneDeep from 'lodash/cloneDeep';
import isNumber from 'lodash/isNumber';

var recursiveModifierMapperCore = (modifierGroups, menuModifierGroups, menuModifierItems, copyData, modifierGroupLevel = 0) => {
  const mappedModifiers = Object.values(modifierGroups).reduce((accMG, modifierGroup) => {
    if (!modifierGroup.active || !modifierGroup.inheritedActive)
      return accMG;
    const menuModifierGroup = menuModifierGroups[modifierGroup.modifierGroupId];
    const modifierItems = modifierGroup.modifierItems;
    const originalModifierGroupData = menuModifierGroups[modifierGroup.modifierGroupId];
    const isAllMod = modifierGroup.isAllMod;
    const mappedModifierGroupModifierItems = modifierItemToTicketElementModifierItemCore(
      modifierItems,
      isAllMod,
      menuModifierGroups,
      menuModifierItems,
      copyData,
      modifierGroupLevel,
      originalModifierGroupData
    );
    const mappedModifierGroup = __spreadProps(__spreadValues({}, accMG), {
      [modifierGroup.modifierGroupId]: __spreadProps(__spreadValues({}, modifierGroup), {
        posName: menuModifierGroup.posName,
        checkName: menuModifierGroup.checkName,
        backgroundColor: menuModifierGroup.backgroundColor,
        textColor: menuModifierGroup.textColor,
        quantityMode: menuModifierGroup.quantityMode,
        modifierItems: mappedModifierGroupModifierItems,
        maximumModifierItems: modifierGroup.maximumModifierItems || menuModifierGroup.maximumModifierItems,
        // fallback while menu screen is updated
        priceCalcMode: menuModifierGroup.priceCalcMode,
        allowNoneSelection: menuModifierGroup.allowNoneSelection,
        hidePriceIfFree: menuModifierGroup.hidePriceIfFree,
        activeCustomizerSectionSelector: menuModifierGroup.activeCustomizerSectionSelector,
        multiselect: menuModifierGroup.multiselect,
        locationModifierGroupId: menuModifierGroup.locationModifierGroupId,
        locationModifierGroupVersionId: menuModifierGroup.locationModifierGroupVersionId,
        showSearchBar: menuModifierGroup.showSearchBar,
        searchAllModifierItems: menuModifierGroup.searchAllModifierItems,
        showModGroupTitleOnRegisterTicket: menuModifierGroup.showModGroupTitleOnRegisterTicket,
        sortPriority: modifierGroup.sortPriority,
        enableModTags: menuModifierGroup.enableModTags,
        enableQuantityBar: menuModifierGroup.enableQuantityBar,
        customizerSlicing: menuModifierGroup.customizerSlicing
      })
    });
    return mappedModifierGroup;
  }, {});
  return mappedModifiers;
};
var modifierItemToTicketElementModifierItemCore = (modifierItems, isAllModParentMG, menuModifierGroups, menuModifierItems, copyData, parentModifierGroupLevel, originalModifierGroupData) => Object.values(modifierItems).reduce((accMI, modifierGroupModifierItem) => {
  var _a;
  if (!modifierGroupModifierItem.active || !modifierGroupModifierItem.inheritedActive)
    return accMI;
  if (copyData && parentModifierGroupLevel === 0 && !modifierGroupModifierItem.isSelected)
    return accMI;
  const modifierItem = copyData ? cloneDeep(menuModifierItems[modifierGroupModifierItem.modifierItemId]) : __spreadValues({}, menuModifierItems[modifierGroupModifierItem.modifierItemId]);
  if (parentModifierGroupLevel > 1 || (originalModifierGroupData == null ? void 0 : originalModifierGroupData.activeCustomizerSectionSelector)) {
    modifierItem.modifierGroups = {};
  }
  const mappedSecondLevelModifierGroups = recursiveModifierMapperCore(
    modifierItem.modifierGroups,
    menuModifierGroups,
    menuModifierItems,
    copyData,
    parentModifierGroupLevel + 1
  );
  const mappedModifierGroupModifierItem = __spreadProps(__spreadValues({}, modifierGroupModifierItem), {
    isSelected: modifierGroupModifierItem.isSelected,
    name: modifierItem.name,
    posName: modifierItem.posName,
    checkName: modifierItem.checkName,
    kdsName: modifierItem.kdsName,
    modifierGroups: mappedSecondLevelModifierGroups,
    locationModifierItemId: modifierItem.locationModifierItemId,
    locationModifierItemVersionId: modifierItem.locationModifierItemVersionId,
    defaultQuantitySelected: modifierGroupModifierItem.isSelected ? (_a = modifierGroupModifierItem.defaultQuantitySelected) != null ? _a : 1 : 0,
    includedMasterPrice: isNumber(
      modifierGroupModifierItem.includedMasterPrice
    ) ? modifierGroupModifierItem.includedMasterPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].includedMasterPrice,
    additionalMasterPrice: isNumber(
      modifierGroupModifierItem.additionalMasterPrice
    ) ? modifierGroupModifierItem.additionalMasterPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].additionalMasterPrice,
    includedLightPrice: isNumber(
      modifierGroupModifierItem.includedLightPrice
    ) ? modifierGroupModifierItem.includedLightPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].includedLightPrice,
    includedRegularPrice: isNumber(
      modifierGroupModifierItem.includedRegularPrice
    ) ? modifierGroupModifierItem.includedRegularPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].includedRegularPrice,
    includedExtraPrice: isNumber(
      modifierGroupModifierItem.includedExtraPrice
    ) ? modifierGroupModifierItem.includedExtraPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].includedExtraPrice,
    additionalLightPrice: isNumber(
      modifierGroupModifierItem.additionalLightPrice
    ) ? modifierGroupModifierItem.additionalLightPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].additionalLightPrice,
    additionalRegularPrice: isNumber(
      modifierGroupModifierItem.additionalRegularPrice
    ) ? modifierGroupModifierItem.additionalRegularPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].additionalRegularPrice,
    additionalExtraPrice: isNumber(
      modifierGroupModifierItem.additionalExtraPrice
    ) ? modifierGroupModifierItem.additionalExtraPrice : modifierItem.modifierItemPricingVersions[modifierItem.defaultModifierItemPricingVersionId].additionalExtraPrice,
    spacesBefore: originalModifierGroupData ? originalModifierGroupData.modifierItems[modifierGroupModifierItem.modifierItemId].spacesBefore : 0,
    linesBefore: originalModifierGroupData ? originalModifierGroupData.modifierItems[modifierGroupModifierItem.modifierItemId].linesBefore : 0
  });
  return __spreadProps(__spreadValues({}, accMI), {
    [modifierGroupModifierItem.modifierItemId]: mappedModifierGroupModifierItem
  });
}, {});

export { modifierItemToTicketElementModifierItemCore, recursiveModifierMapperCore };
